// extracted by mini-css-extract-plugin
export default {"menuBlock":"WD-z","title":"XD-z","nav":"YD-z","flexCell":"ZD-z","facetLink":"_D-z"};